import React from 'react';
import { PartyPopper } from 'lucide-react';

export default function KeepGoingDialog({
  open,
  finishedTitle,
  nextTitle,
  onKeepGoing,
  onDone,
  onBrowseCatalog,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="keep-going-title"
    >
      <div className="w-full max-w-sm rounded-2xl border border-pp-line bg-pp-surface p-5 shadow-pp-lg">
        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-pp-accent/10 text-pp-accent">
          <PartyPopper className="h-5 w-5" aria-hidden />
        </div>
        <h2 id="keep-going-title" className="text-lg font-semibold text-pp-ink">
          {finishedTitle} complete
        </h2>
        <p className="mt-2 text-sm text-pp-muted">
          {nextTitle
            ? `Ready for the next tour: ${nextTitle}?`
            : 'You have finished the recommended sequence. Browse the catalog anytime for a refresher.'}
        </p>
        <div className="mt-5 flex flex-col gap-2">
          {nextTitle ? (
            <button
              type="button"
              onClick={onKeepGoing}
              className="w-full rounded-xl bg-pp-accent px-4 py-2.5 text-sm font-semibold text-white hover:bg-pp-accentHover"
            >
              Keep going — {nextTitle}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onBrowseCatalog}
            className="w-full rounded-xl border border-pp-line px-4 py-2.5 text-sm font-medium text-pp-ink hover:bg-pp-paper"
          >
            Browse all tours
          </button>
          <button
            type="button"
            onClick={onDone}
            className="w-full py-2 text-sm font-medium text-pp-muted hover:text-pp-ink"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
